export const programme_day = [
    {
        "uuid":"uuiduuiduuid01",
        "company":"Company A",
        "actions":[
            {
                "action":"Action 1 description blabl blabl"
            },{
                "action":"Action 2 description blabl blabl"
            },{
                "action":"Action 3 description blabl blabl"
            }
        ],
        "city":"Casablanca",
        "status":"inProgress"
    },{
        "uuid":"uuiduuiduuid02",
        "company":"Company B",
        "actions":[
            {
                "action":"Action 1 description blabl blabl"
            },{
                "action":"Action 2 description blabl blabl"
            },{
                "action":"Action 3 description blabl blabl"
            }
        ],
        "city":"Mohammedia",
        "status":"planified"
    },{
        "uuid":"uuiduuiduuid03",
        "company":"Company C",
        "actions":[
            {
                "action":"Action 1 description blabl blabl"
            },{
                "action":"Action 2 description blabl blabl"
            },{
                "action":"Action 3 description blabl blabl"
            }
        ],
        "city":"Rabat",
        "status":"planified"
    },{
        "uuid":"uuiduuiduuid04",
        "company":"Company D",
        "actions":[
            {
                "action":"Action 1 description blabl blabl"
            },{
                "action":"Action 2 description blabl blabl"
            },{
                "action":"Action 3 description blabl blabl"
            }
        ],
        "city":"Salé",
        "status":"planified"
    }
]